import { authApi } from "./authApi";
import { toastError } from "@/components/custom/Toast";
export const service = {
  postFun,
  getFun,
};

function postFun(data, endPoint) {
  return authApi
    .post(endPoint, data)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}
function getFun(endPoint, params) {
  return authApi
    .get(endPoint, { params: params })
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

export function handleResponse(response) {
  // debugger;
  if (response.data.status_code == 404 || response.data.success == false) {
    return toastError(response.data.errors[0]);
  } else {
    return response.data;
  }
}
